import { useCallback, useEffect, useRef } from 'react';
import { useAuth, useAuthEvent, AuthErrorCode } from '@bedrock/auth';
import {
  LOGIN_REGISTRATION_MODAL,
  PHONE_NUMBER_MODAL,
  PRIVATE_EMAIL_EXPOSED_MODAL,
  SOCIAL_SIGN_IN_ERROR_MODAL,
  useModalContext,
} from 'contexts/modal';
import type { IModalContext } from 'contexts/modal';
import { useRouteSettled } from 'hooks/use-route-settled';
import { useAuthAnalytics } from './use-auth-analytics';

export default function PostAuthActionHandler() {
  const { consumePendingAction } = useAuth();
  const settled = useRouteSettled();
  const { openModal } = useModalContext<IModalContext>();

  useAuthAnalytics();

  useAuthEvent('needs_phone_post_auth', useCallback(() => {
    openModal(PHONE_NUMBER_MODAL, {});
  }, [openModal]));

  const handledRef = useRef(false);

  useEffect(() => {
    if (!settled) {
      handledRef.current = false;
      return;
    }
    if (handledRef.current) return;
    handledRef.current = true;

    const action = consumePendingAction();
    if (!action) return;

    switch (action.type) {
      case 'collect_phone':
        openModal(LOGIN_REGISTRATION_MODAL, { collectPhone: true });
        break;
      case 'error':
        if (action.code === AuthErrorCode.PrivateEmailExposed) {
          openModal(PRIVATE_EMAIL_EXPOSED_MODAL);
        } else {
          openModal(SOCIAL_SIGN_IN_ERROR_MODAL);
        }
        break;
    }
  }, [settled, consumePendingAction, openModal]);

  return null;
}
